import { useLocationState } from "../../../../../core/router/routerHooks"
import type { IMyOrderDetails } from "../../../../payments/orderTypes"
import type { MonetaryAmount } from "../../../../currency/currencyTypes"
import type { TakeawayKitchen } from "../../../../../shared/components/createOrder/components/takeaway/takeawayTypes"

import { TakeawayOrderConfirmed } from "../components/TakeawayOrderConfirmed"

type LocationState = Readonly<{
    orders: IMyOrderDetails[] | undefined
    kitchen: TakeawayKitchen | undefined
    totalPrice: MonetaryAmount | undefined
}>

export function TakeawayPaymentSuccess() {
    const { orders, kitchen, totalPrice } = useLocationState<LocationState>({ orders: undefined, kitchen: undefined, totalPrice: undefined })

    return <TakeawayOrderConfirmed orders={orders} kitchen={kitchen} totalPrice={totalPrice} />
}
